
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casino/crash",
      function () {
        return require("private-next-pages/casino/crash/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casino/crash"])
      });
    }
  